import { ProviderResultItem } from '~/clients';

export function providerKeyResolver({ id, location, specialty }: ProviderResultItem): string {
  return `${id}|${location.id}|${specialty}`;
}
